import { useMemo } from "react"

/**
 * Calculates start and end dates for a calendar view based on params.
 * @param {Object} params - Calendar filter params (must include date, range)
 * @returns {{start: string, end: string}} - Start and end ISO date strings
 */
export function useCalendarDateRange(params) {
  return useMemo(() => {
    if (!params.date || !params.range) return {}
    const range = params.range === "week" ? "weekDay" : params.range
    const date = global.dateTime(params.date)
    const dates = {}

    if (params.range === "month") {
      dates.start = date.clone.startOf(range).startOf("weekDay", 1).format()
      dates.end = date.clone.endOf(range).endOf("weekDay", 1).format()
    } else {
      dates.start = date.clone.startOf(range, 1).format()
      dates.end = date.clone.endOf(range, 1).format()
    }

    return dates
  }, [params.date, params.range])
}
